import { Component, Inject, Input } from "@angular/core";
import { CommonModule } from '@angular/common';
import { FieldOkItemComponent } from "@softline/dynamic";

@Component({
    selector: 'soft-field-ok-data-view',
    imports: [CommonModule],
    templateUrl: './maschine.list-view.html',
    styleUrls: ['./maschine.list-view.scss']
})
export class MaschineListView implements FieldOkItemComponent<any>{

  @Input() item: any;

  constructor() {
  }
}
